import pluralize, { singular } from "pluralize";

type RateUnit = "hour" | "day";

// Accepts `number` (from the binding form, current V2 migration) and `string`
// (from the DPC form, still on MUI TextField) until migration is complete.
export function formatRateExpression(
  unit: RateUnit,
  period?: number | null,
): string | null {
  if (period && period > 0) {
    return `rate(${period} ${pluralize(unit, period)})`;
  }
  return null;
}

// https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-rate-expressions.html
export function parseSchedule(scheduleExp: string): {
  period?: number;
  unit?: RateUnit;
  cron?: string;
} | null {
  const rateRegex = /([0-9]+) (\w+)/;
  const cronRegex = /\(([^)]+)\)/;

  if (scheduleExp.startsWith("rate")) {
    const match = scheduleExp.match(rateRegex);
    if (match) {
      const period = parseInt(match[1], 10);
      const unit = singular(match[2]) as RateUnit;
      return {
        period,
        unit,
      };
    }
  }

  if (scheduleExp.startsWith("cron")) {
    const match = scheduleExp.match(cronRegex);
    if (match) {
      return {
        cron: match[1],
      };
    }
  }
  return null;
}
